import { useDisclosure, VStack } from '@chakra-ui/react';
import { type FC, useState } from 'react';

import { DeleteTeacherInvitationModal } from '$/pages/SchoolPage/components/DeleteTeacherInvitationModal';
import { EditTeacherInvitationModal } from '$/pages/SchoolPage/components/EditTeacherInvitationModal';
import { TeacherInvitationCard } from '$/pages/SchoolPage/components/TeacherInvitationCard';
import { type TeacherInvitationRequest } from '$/services/usecases/invitation/mapper/invitation';

interface Props {
  teacherInvitations: TeacherInvitationRequest[];
}

export const TeacherInvitationCardList: FC<Props> = ({
  teacherInvitations,
}) => {
  const editModal = useDisclosure();
  const deleteModal = useDisclosure();

  const [selectedInvitation, setSelectedInvitation] =
    useState<TeacherInvitationRequest | null>(null);

  const handleEdit = (invitation: TeacherInvitationRequest) => {
    setSelectedInvitation(invitation);
    editModal.onOpen();
  };

  const handleDelete = (invitation: TeacherInvitationRequest) => {
    setSelectedInvitation(invitation);
    deleteModal.onOpen();
  };

  return (
    <>
      <VStack w='full'>
        {teacherInvitations.map((invitation) => (
          <TeacherInvitationCard
            key={invitation.id}
            teacherInvitation={invitation}
            onEdit={handleEdit}
            onDelete={handleDelete}
          />
        ))}
      </VStack>

      {selectedInvitation != null && (
        <>
          <EditTeacherInvitationModal
            invitation={selectedInvitation}
            isOpen={editModal.isOpen}
            onClose={editModal.onClose}
          />
          <DeleteTeacherInvitationModal
            invitation={selectedInvitation}
            isOpen={deleteModal.isOpen}
            onClose={deleteModal.onClose}
          />
        </>
      )}
    </>
  );
};
